import React from 'react';
import { Stack, Typography, Box, } from '@mui/material';
import { ThemeProvider,  } from '@mui/material/styles';
import { lightTheme, } from '../../components/themes/main_theme.js';
import GroupsIcon from '@mui/icons-material/Groups';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import HandshakeIcon from '@mui/icons-material/Handshake';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import EmailIcon from '@mui/icons-material/Email';
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary';
import ArticleIcon from '@mui/icons-material/Article';

const GetIcons = (props: any) => {
    const {name } = props
    switch (name) {
        case 'ABOUT US':
            return <GroupsIcon {...props} />
        case 'NEWS':
            return <NewspaperIcon {...props} />
        case 'MINISTRIES':
            return <HandshakeIcon {...props} />
        case 'GALLERY':
            return <PhotoLibraryIcon {...props} />
        case 'BLOG':
            return <ArticleIcon {...props} />
        case 'DONATE':
            return <VolunteerActivismIcon {...props} />
        case 'CONTACT US': 
            return <EmailIcon {...props} />
        default:
            break;
    }
}

const Header = (props: any) => {
    const { name, } = props;

    return (
    <ThemeProvider theme={lightTheme}>
        <Stack direction={'row'} spacing={1.5} mt={{xs: 3, md: 5}} mx={{ xs: 2, sm: 3, md: 5 }} sx={{alignItems: 'center', justifyContent: 'flex-start' }}>
            <GetIcons name={name} fontSize="large" color='primary' sx={{mr: 1}}/>
            <Typography variant="h4" alignContent={'center'} color="primary">{name}</Typography>
        </Stack>  
    </ThemeProvider>
    );
};

export default Header;